import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ScrollTextIcon, ArrowLeftIcon, MailIcon } from 'lucide-react';
import { GlitterHeart } from '../components/GlitterHeart';
interface Section {
  title: string;
  content: React.ReactNode;
}
const sections: Section[] = [{
  title: '1. Eligibility',
  content: <div className="space-y-3" data-id="element-3138" data-mp="2f9bzdfo8l9bv">
        <p data-id="element-3139" data-mp="2t6qqqpy1vr6h">
          You must be at least 18 years old, or have permission from a parent or
          legal guardian, to use our services.
        </p>
        <p data-id="element-3140" data-mp="2o7nnnb1mrv15">
          By using our services, you confirm that you are legally able to enter
          into this agreement.
        </p>
      </div>
}, {
  title: '2. Informational & Educational Purposes Only',
  content: <div className="space-y-3" data-id="element-3141" data-mp="3bxi19utrxnmg">
        <p data-id="element-3142" data-mp="3byjkwnouvifs">
          Our content is provided for informational, educational, motivational,
          entertainment, and organizational purposes only.
        </p>
        <p data-id="element-3143" data-mp="2vn7k1o3qevmz">We do not provide:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3144" data-mp="2vo960nmad2jh">
          <li data-id="element-3145" data-mp="2zo9hq0i02zmu">medical advice</li>
          <li data-id="element-3146" data-mp="2zpkng5v0ahgl">mental health treatment</li>
          <li data-id="element-3147" data-mp="2zqm6oxm6ea9e">therapy services</li>
          <li data-id="element-3148" data-mp="34nmepe2l5n35">legal advice</li>
          <li data-id="element-3149" data-mp="34mb2qqyzl90y">financial advice</li>
          <li data-id="element-3150" data-mp="39mz15xpjos57">professional counseling</li>
        </ul>
        <p data-id="element-3151" data-mp="39nrzqbecobc9">
          Any wellness, motivational, self-care, relationship, organizational,
          travel, or productivity content should not replace professional
          guidance from licensed professionals.
        </p>
        <p data-id="element-3152" data-mp="3ilkgzl3mtt2a">
          Always seek appropriate professional assistance for medical, legal,
          financial, or mental health concerns.
        </p>
      </div>
}, {
  title: '3. AI-Generated Content Disclaimer',
  content: <div className="space-y-3" data-id="element-3153" data-mp="17p2z0os072p">
        <p data-id="element-3154" data-mp="18qgdbt9l5nl">
          Some content, recommendations, visuals, scheduling tools, checklists,
          prompts, or resources may be generated or assisted by artificial
          intelligence (AI).
        </p>
        <p data-id="element-3155" data-mp="3cns643z04pzw">
          AI-generated content may occasionally contain inaccuracies, errors,
          outdated information, or incomplete recommendations.
        </p>
        <p data-id="element-3156" data-mp="3mdk12zb0jl4w">
          Users are responsible for independently verifying important
          information before relying on it.
        </p>
        <p data-id="element-3157" data-mp="3hlaiy5g53pd6">
          We are not liable for decisions made based on AI-generated content or
          recommendations.
        </p>
      </div>
}, {
  title: '4. User Accounts',
  content: <div className="space-y-3" data-id="element-3158" data-mp="3qgzy3wqzvni4">
        <p data-id="element-3159" data-mp="96ibxqn6esbq">Some services may require account creation.</p>
        <p data-id="element-3160" data-mp="960it2vt8u81">You agree to:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3161" data-mp="47p8kr1lshpa">
          <li data-id="element-3162" data-mp="45m97gek9c7w">provide accurate information</li>
          <li data-id="element-3163" data-mp="2axdaurcoj7mo">maintain the security of your account</li>
          <li data-id="element-3164" data-mp="2b09b4mc028ea">keep login credentials confidential</li>
          <li data-id="element-3165" data-mp="2603q3p08jk56">notify us of unauthorized account activity</li>
        </ul>
        <p data-id="element-3166" data-mp="lh9q6j0ttbr1">
          We reserve the right to suspend or terminate accounts that violate
          these Terms.
        </p>
      </div>
}, {
  title: '5. Subscriptions, Payments & Digital Products',
  content: <div className="space-y-3" data-id="element-3167" data-mp="bq6obf02osqp">
        <p data-id="element-3168" data-mp="bqya5y3vbc3s">
          Certain features, memberships, subscriptions, courses, downloads,
          games, or digital products may require payment.
        </p>
        <p data-id="element-3169" data-mp="2qa1zk15o5yt">By purchasing or subscribing, you agree that:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3170" data-mp="2sw8dgcb8ffg">
          <li data-id="element-3171" data-mp="6tg9ev00836v">payment information provided is accurate</li>
          <li data-id="element-3172" data-mp="3oyjj6t0x13dm">subscription charges may renew automatically unless canceled</li>
          <li data-id="element-3173" data-mp="3twkxl0neceir">pricing may change at any time</li>
          <li data-id="element-3174" data-mp="3txctkckwoe9k">
            access to paid content may be modified, updated, or discontinued
          </li>
        </ul>
        <p data-id="element-3175" data-mp="1n4adm7vptspf">
          Unless otherwise stated, digital purchases and downloadable products
          are generally non-refundable.
        </p>
        <p data-id="element-3176" data-mp="3o8us1l4kcpkh">Refund decisions may be made at our discretion.</p>
      </div>
}, {
  title: '6. Acceptable Use',
  content: <div className="space-y-3" data-id="element-3177" data-mp="3ja1fpw10j4lw">
        <p data-id="element-3178" data-mp="3f7wjqqn3dvw3">You agree not to:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3179" data-mp="3f750mfaolqmp">
          <li data-id="element-3180" data-mp="3a93grs5flna6">misuse the services</li>
          <li data-id="element-3181" data-mp="3a81vyvym5mf9">interfere with platform functionality</li>
          <li data-id="element-3182" data-mp="359gtepvw2qnn">attempt unauthorized access</li>
          <li data-id="element-3183" data-mp="35aie7m2pirik">upload malicious software or harmful content</li>
          <li data-id="element-3184" data-mp="30iibjlv95kia">harass, threaten, or abuse other users</li>
          <li data-id="element-3185" data-mp="30gxftsx7bviu">post illegal, hateful, or inappropriate material</li>
          <li data-id="element-3186" data-mp="2vkyuke766tmn">copy, resell, or exploit our content without permission</li>
        </ul>
        <p data-id="element-3187" data-mp="2rj50iorhcnvg">
          We reserve the right to remove content or terminate access for
          violations.
        </p>
      </div>
}, {
  title: '7. Community Features & User Content',
  content: <div className="space-y-3" data-id="element-3188" data-mp="2hl7fea4x3772">
        <p data-id="element-3189" data-mp="2hm8z1300120e">
          If community, multiplayer, social, chat, livestream, or user-submitted
          features are available, users remain responsible for their own conduct
          and submissions.
        </p>
        <p data-id="element-3190" data-mp="123197xl4ftqu">
          By submitting content, you grant us a non-exclusive right to display,
          distribute, or use that content in connection with operating the
          platform.
        </p>
        <p data-id="element-3191" data-mp="1azk0749sl7ks">We reserve the right to remove content that violates these Terms.</p>
      </div>
}, {
  title: '8. Intellectual Property',
  content: <div className="space-y-3" data-id="element-3192" data-mp="jb8iyaxfsmmt">
        <p data-id="element-3193" data-mp="j8ciaeu7fjuo">
          All branding, logos, graphics, content, designs, downloads, app
          concepts, game concepts, checklists, visuals, text, and materials
          associated with Trippin' with Mandy and related brands are protected
          by copyright and intellectual property laws.
        </p>
        <p data-id="element-3194" data-mp="3vs3zh8tiee6w">You may not:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3195" data-mp="3vrc5u3jh2qj9">
          <li data-id="element-3196" data-mp="12xdlonrpg275">copy</li>
          <li data-id="element-3197" data-mp="12wvewx7f25kz">reproduce</li>
          <li data-id="element-3198" data-mp="12w2jgsdwr2i5">resell</li>
          <li data-id="element-3199" data-mp="12val59sxeqo6">redistribute</li>
          <li data-id="element-3200" data-mp="xz2ao9poblnc">modify</li>
          <li data-id="element-3201" data-mp="xxiraa8q0uhc">commercially exploit</li>
        </ul>
        <p data-id="element-3202" data-mp="1cngo1ekpusi5">our content without written permission.</p>
      </div>
}, {
  title: '9. Third-Party Services',
  content: <div className="space-y-3" data-id="element-3203" data-mp="17o3r2104s51u">
        <p data-id="element-3204" data-mp="17p5dt2qiefze">
          Our services may integrate with or link to third-party platforms,
          including payment processors, app stores, analytics providers, social
          media platforms, scheduling systems, or AI tools.
        </p>
        <p data-id="element-3205" data-mp="sz7lcaljr44e">We are not responsible for:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3206" data-mp="t08v8bqttkkj">
          <li data-id="element-3207" data-mp="oxmb6x0ed3xw">third-party services</li>
          <li data-id="element-3208" data-mp="owkmvqudeky8">third-party policies</li>
          <li data-id="element-3209" data-mp="24ecoffplb4oj">outages</li>
          <li data-id="element-3210" data-mp="24dl4j25cuve3">security practices</li>
          <li data-id="element-3211" data-mp="24ctavwvbj7qg">content hosted externally</li>
        </ul>
        <p data-id="element-3212" data-mp="20dsqi9x6zx1c">
          Use of third-party services is subject to their own terms and
          policies.
        </p>
      </div>
}, {
  title: '10. No Guarantees',
  content: <div className="space-y-3" data-id="element-3213" data-mp="2cw6cl3ru0blh">
        <p data-id="element-3214" data-mp="2cx7zc5i7mmj1">We do not guarantee:</p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3215" data-mp="2ctaf1gjwboxk">
          <li data-id="element-3216" data-mp="1y0743s0t89ft">specific business results</li>
          <li data-id="element-3217" data-mp="22wxjed4sj106">income</li>
          <li data-id="element-3218" data-mp="22yidk1n70hxi">follower growth</li>
          <li data-id="element-3219" data-mp="22zjrcdvlfiix">mental health improvements</li>
          <li data-id="element-3220" data-mp="2qmi719bw2mfs">productivity outcomes</li>
          <li data-id="element-3221" data-mp="2qnjphyv8ib7j">relationship outcomes</li>
          <li data-id="element-3222" data-mp="2vlv22hcwyztg">app availability without interruption</li>
          <li data-id="element-3223" data-mp="2vllcguvs6uoa">error-free operation</li>
        </ul>
        <p data-id="element-3224" data-mp="2gxi63kdttgyy">Results vary by individual circumstances.</p>
      </div>
}, {
  title: '11. Limitation of Liability',
  content: <div className="space-y-3" data-id="element-3225" data-mp="2luqnhir5hgz5">
        <p data-id="element-3226" data-mp="2ltyri6tn5h8c">
          To the fullest extent permitted by law, Trippin' with Mandy and its
          owners, affiliates, partners, employees, contractors, or
          representatives shall not be liable for:
        </p>
        <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2" data-id="element-3227" data-mp="1ea4lfuijr29h">
          <li data-id="element-3228" data-mp="1ec7kt55la7qv">indirect damages</li>
          <li data-id="element-3229" data-mp="19jedqamnenbm">lost profits</li>
          <li data-id="element-3230" data-mp="19i3bwgcrjpn5">data loss</li>
          <li data-id="element-3231" data-mp="19htjyn85r8et">emotional distress</li>
          <li data-id="element-3232" data-mp="15h9mtjnl44so">business interruption</li>
          <li data-id="element-3233" data-mp="15iaz1rgc6xbz">inaccuracies</li>
          <li data-id="element-3234" data-mp="10iye5c9100c1">technical issues</li>
          <li data-id="element-3235" data-mp="10jrdvt9khpko">decisions made using our content or tools</li>
        </ul>
        <p data-id="element-3236" data-mp="1x8yz1069xwo2">Use of our services is at your own risk.</p>
      </div>
}, {
  title: '12. Termination',
  content: <p data-id="element-3237" data-mp="1t8otfome989q">
        We reserve the right to suspend, restrict, or terminate access to
        services at any time for violations of these Terms or misuse of the
        platform.
      </p>
}, {
  title: '13. Changes to Terms',
  content: <div className="space-y-3" data-id="element-3238" data-mp="1jbtu53iar3ue">
        <p data-id="element-3239" data-mp="ctnksfu0987x">We may update these Terms & Conditions at any time.</p>
        <p data-id="element-3240" data-mp="cr149qp4zidk">
          Continued use of the services after updates means you accept the
          revised Terms.
        </p>
      </div>
}, {
  title: '14. Governing Law',
  content: <p data-id="element-3241" data-mp="3ttx5lccjiepo">
        These Terms shall be governed by the laws of the State of Florida,
        United States, without regard to conflict of law principles.
      </p>
}, {
  title: '15. Contact Information',
  content: <div className="space-y-3" data-id="element-3242" data-mp="cfia1cby46cl">
        <p data-id="element-3243" data-mp="cgtbv6ltz412">For questions regarding these Terms & Conditions, please contact:</p>
        <a href="mailto:trippinwithmandy@gmail.com" className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl bg-blush-100 hover:bg-blush-200 text-plum-800 font-bold transition-colors" data-id="element-3244" data-mp="gftvgrc4uap4">
          <MailIcon className="w-5 h-5" data-id="element-3245" data-mp="qft1agh63mya" />
          trippinwithmandy@gmail.com
        </a>
      </div>
}];
export function TermsPage() {
  return <div className="min-h-screen bg-gradient-to-b from-lavender-50 via-white to-blush-50 pt-28 pb-24" data-id="element-3246" data-mp="2s6xp11fzc3dc">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3247" data-mp="2x4pihzw9vxjn">
        {/* Back link */}
        <Link to="/" className="inline-flex items-center gap-2 text-plum-500 hover:text-plum-700 font-bold text-sm mb-8 transition-colors" data-id="element-3248" data-mp="pf0jp6wbgsyk">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-3249" data-mp="ufeu2vle4ezr" />
          Back to Home
        </Link>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-3250" data-mp="13e8m08ns0h6z">
          <div className="flex justify-center mb-4" data-id="element-3251" data-mp="1dbwfkv9nbink">
            <GlitterHeart size={32} data-id="element-3252" data-mp="1dabo5eimoftx" />
          </div>
          <div className="w-16 h-16 rounded-2xl bg-lavender-100 flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-3253" data-mp="1i2wf88a5getr">
            <ScrollTextIcon className="w-8 h-8 text-plum-600" data-id="element-3254" data-mp="1m487klkere5n" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-plum-800 mb-3" data-id="element-3255" data-mp="1r4vwn1p2tkx8">
            Terms & Conditions
          </h1>
          <p className="text-plum-500 font-medium" data-id="element-3256" data-mp="1w3763bbgltex">For Trippin' with Mandy</p>
          <p className="text-plum-400 text-sm font-medium mt-1" data-id="element-3257" data-mp="267nke09aj2gm">
            Last Updated: May 12, 2026
          </p>
        </motion.div>

        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-white rounded-3xl p-8 shadow-sm border border-lavender-100 mb-8" data-id="element-3258" data-mp="1w8extsgr8q4a">
          <p className="text-plum-700 leading-relaxed mb-4" data-id="element-3259" data-mp="2jzka5xnhl09u">
            Welcome to Trippin' with Mandy, including all related brands, apps,
            websites, games, digital products, coaching content, services, and
            platforms operated by Amanda Randolph ("Company," "we," "our," or
            "us"), including but not limited to:
          </p>
          <ul className="list-disc list-inside space-y-1 text-plum-600 pl-2 mb-4" data-id="element-3260" data-mp="32xdbivigp254">
            <li data-id="element-3261" data-mp="10zl0t315h5zm">Trippin' Through Life</li>
            <li data-id="element-3262" data-mp="110mc98m2vuhv">Trippin' Through Life: The Game</li>
            <li data-id="element-3263" data-mp="111xidf2zxec5">Trippin' Through Life apps and tools</li>
            <li data-id="element-3264" data-mp="15xct3y5piu4c">Trippin' with Mandy websites and social platforms</li>
            <li data-id="element-3265" data-mp="rabanspv9xe5">Digital downloads, courses, guides, and checklists</li>
            <li data-id="element-3266" data-mp="r7xcvc3sy72w">Coaching, wellness, and educational resources</li>
            <li data-id="element-3267" data-mp="w7a2u5pyzu9p">Community features, memberships, and subscription services</li>
          </ul>
          <p className="text-plum-700 leading-relaxed font-medium mb-3" data-id="element-3268" data-mp="i8a9ikriir77">
            By accessing or using our websites, apps, services, products, or
            content, you agree to these Terms & Conditions.
          </p>
          <p className="text-plum-700 leading-relaxed font-medium" data-id="element-3269" data-mp="8d0be848j3yp">
            If you do not agree to these Terms, please do not use our services.
          </p>
        </motion.div>

        {/* Sections */}
        <div className="space-y-6" data-id="element-3270" data-mp="22n3yisfje1ox">
          {sections.map((section, idx) => <motion.section key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.03
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-lavender-100" data-id="element-3271" data-mp="27n8duf4pkqdk" data-mpi={idx}>
              <h2 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-3272" data-mp="epcmc8r0p0vq">
                {section.title}
              </h2>
              <div className="text-plum-600 leading-relaxed space-y-3" data-id="element-3273" data-mp="opbsjyzysf5f">
                {section.content}
              </div>
            </motion.section>)}
        </div>

        {/* Footer links */}
        <div className="text-center mt-12 flex flex-wrap justify-center gap-3" data-id="element-3274" data-mp="2qggi8pic75n4">
          <Link to="/privacy" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border border-plum-200 text-plum-700 hover:bg-plum-50 font-bold text-sm transition-colors" data-id="element-3275" data-mp="2qijhm05dqb4i">
            View Privacy Policy
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-cta-500 text-white hover:bg-cta-600 font-bold text-sm transition-colors shadow-lg shadow-cta-500/20" data-id="element-3276" data-mp="2rzypdahkcswk">
            Back to Home
          </Link>
        </div>
      </div>
    </div>;
}